<div class="logout-background">
  <div class="logout-container">
    <h1>{{ 'ACCOUNT.LOGOUT_HEADER' | translate }}</h1>
    <p>{{ message | async | translate }}</p>
    <a href="/">{{ 'ACCOUNT.LOGIN_AGAIN' | translate }}</a>
  </div>
</div>
